import React, { useState } from 'react';
import PageBanner from '../components/PageBanner';

const COOKIE_TYPES = [
  {
    key: 'essential',
    title: 'ملفات أساسية',
    desc: 'ضرورية لتشغيل الموقع بشكل صحيح، مثل تسجيل الدخول وسلة التسوق. لا يمكن تعطيلها.',
    locked: true,
  },
  {
    key: 'performance',
    title: 'ملفات الأداء',
    desc: 'بتساعدنا نفهم إزاي بتستخدم الموقع عشان نحسّن السرعة وتجربة الاستخدام.',
    locked: false,
  },
  {
    key: 'marketing',
    title: 'ملفات التسويق',
    desc: 'بتُستخدم لعرض إعلانات وعروض أقرب لاهتماماتك على المنصة ومواقع تانية.',
    locked: false,
  },
];

const CookiesPolicy = () => {
  const [prefs, setPrefs] = useState({ essential: true, performance: true, marketing: false });
  const [saved, setSaved] = useState(false);

  const togglePref = (key) => {
    if (key === 'essential') return;
    setPrefs((p) => ({ ...p, [key]: !p[key] }));
    setSaved(false);
  };

  return (
    <div dir="rtl">
      <PageBanner
        eyebrow="آخر تحديث: يوليو 2026"
        title="سياسة ملفات تعريف الارتباط"
        subtitle="نستخدم أنواع مختلفة من الكوكيز لتحسين تجربتك، وتقدر تتحكم فيها من هنا."
      />

      <div className="container mx-auto px-4 py-14 max-w-3xl">
        <p className="text-gray-600 leading-8 mb-10">
          ملفات تعريف الارتباط (الكوكيز) هي ملفات نصية صغيرة بتتخزن على جهازك لما تزور موقعنا،
          وبتساعدنا نتذكر تفضيلاتك ونحسّن أداء المنصة. تقدر تتحكم في كل نوع كوكيز من الإعدادات تحت.
        </p>

        <div className="space-y-4 mb-8">
          {COOKIE_TYPES.map((cookie) => (
            <div
              key={cookie.key}
              className="flex items-start justify-between gap-4 bg-white border border-gray-100 rounded-2xl p-6 shadow-[0_2px_10px_rgba(27,27,31,0.05)]"
            >
              <div className="flex-1">
                <h3 className="font-bold text-[#1B1B1F] mb-1">{cookie.title}</h3>
                <p className="text-sm text-gray-600 leading-6">{cookie.desc}</p>
              </div>

              <button
                type="button"
                role="switch"
                aria-checked={prefs[cookie.key]}
                onClick={() => togglePref(cookie.key)}
                disabled={cookie.locked}
                className={`shrink-0 w-12 h-7 rounded-full relative transition-colors duration-300 ${
                  prefs[cookie.key] ? 'bg-[#F2B705]' : 'bg-gray-300'
                } ${cookie.locked ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
              >
                <span
                  className={`absolute top-1 w-5 h-5 rounded-full bg-white shadow transition-all duration-300 ${
                    prefs[cookie.key] ? 'right-1' : 'right-6'
                  }`}
                />
              </button>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <button
            type="button"
            onClick={() => setSaved(true)}
            className="px-8 py-3 rounded-full bg-[#1B1B1F] text-white font-bold hover:bg-[#F2B705] hover:text-[#1B1B1F] transition-colors"
          >
            حفظ التفضيلات
          </button>

          {saved && (
            <span className="text-sm font-bold text-[#1B1B1F]">تم حفظ تفضيلاتك ✓</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CookiesPolicy;
